// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  width: 85%;
  padding-bottom: 1.5rem;
  margin: auto;
  overflow: visible !important;
  min-height: fit-content;
  display: flex;
  flex-direction: column;
}
.calendar-container .day.empty {
  visibility: hidden;
}
.calendar-container .day.other-month {
  opacity: 0.3;
  pointer-events: none;
}
.calendar-container .calendar-header {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 100;
}
.calendar-container .calendar-header select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  position: relative;
  z-index: 100;
  pointer-events: auto;
  color: #374151;
}
.calendar-container .calendar-header select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  z-index: 101;
}
.calendar-container .calendar-header select option {
  background: #fff;
  color: #374151;
  padding: 4px 8px;
}
.calendar-container .calendar-grid {
  display: grid;
  overflow: visible;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  flex: 1 1;
}
.calendar-container .calendar-grid .weekday {
  text-align: center;
  font-weight: 600;
  color: #6b7280;
  padding: 8px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.calendar-container .calendar-grid .day {
  min-height: 40px;
  padding: 6px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  position: relative;
  cursor: pointer;
  overflow: visible;
  transition: all 0.2s ease;
}
.calendar-container .calendar-grid .day:hover {
  z-index: 10000;
}
.calendar-container .calendar-grid .day.empty {
  display: none;
}
.calendar-container .calendar-grid .day.today {
  background: #dbeafe;
  border-color: #3b82f6;
}
.calendar-container .calendar-grid .day.today .day-number {
  font-weight: 700;
  color: #1d4ed8;
}
.calendar-container .calendar-grid .day.has-events {
  background: #f0f9ff;
  border: 2px solid #0ea5e9;
}
.calendar-container .calendar-grid .day.has-events .event-count {
  color: #0284c7;
}
.calendar-container .calendar-grid .day.empty {
  background: transparent;
  border: none;
  cursor: default;
}
.calendar-container .calendar-grid .day:hover:not(.empty) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  border-color: #94a3b8;
}
.calendar-container .calendar-grid .day .day-number {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}
.calendar-container .calendar-grid .day .event-count {
  font-size: 10px;
  color: #0ea5e9;
  margin-top: 2px;
  font-weight: 600;
}
.calendar-container .calendar-grid .day .tooltip {
  position: absolute !important;
  background: white;
  z-index: 99999 !important;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.08);
  min-width: 300px;
  max-width: 380px;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.98);
  max-height: 210px;
  display: flex;
  flex-direction: column;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom, .calendar-container .calendar-grid .day .tooltip.tooltip-left, .calendar-container .calendar-grid .day .tooltip.tooltip-right {
  position: absolute !important;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom {
  top: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top {
  bottom: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right {
  top: 50%;
  left: calc(100% + 3px);
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left {
  top: 50%;
  right: calc(100% + 3px);
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip .tooltip::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-bottom::before {
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-top::before {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-left::before {
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  border-left-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-right::before {
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  border-right-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Tab Navigation */
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 12px 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab .tab-icon {
  font-size: 0.875rem;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:first-child {
  border-radius: 12px 0 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:last-child {
  border-radius: 0 12px 0 0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab.active {
  background: #fff;
  color: #374151;
  border-bottom: 2px solid #3b82f6;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-tabs .tab:hover:not(.active) {
  background: #f1f5f9;
  color: #374151;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Content Area */
}
.calendar-container .calendar-grid .day .tooltip .tooltip-content {
  padding: 16px;
  flex: 1 1;
  overflow-y: auto;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-title {
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-title .section-icon {
  font-size: 1rem;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable {
  max-height: 200px;
  /* Limit height for scrolling */
  padding-right: 4px;
  /* Custom scrollbar */
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar {
  width: 4px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-items.scrollable::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item {
  padding: 10px 12px;
  border-radius: 8px;
  background: #eef2ff;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable {
  cursor: pointer;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable:hover {
  background: #d8e3f7;
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable.task-item {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item.clickable.task-item:hover {
  background: #d1fae5;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .court-ref,
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .task-name {
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .item-badge {
  font-size: 0.625rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  background: #dbeafe;
  color: #1e40af;
  white-space: nowrap;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-header .item-badge.task-badge {
  background: #fef3c7;
  color: #92400e;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-item .item-details {
  font-size: 0.6875rem;
  color: #6b7280;
  line-height: 1.4;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-more {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 6px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
}
.calendar-container .calendar-grid .day .tooltip .tooltip-section .tooltip-more .more-icon {
  font-weight: 700;
  color: #3b82f6;
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn {
  padding: 12px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: #fff;
  border: none;
  border-radius: 0 0 12px 12px;
  font-size: 0.75rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-top: 1px solid #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
}
.calendar-container .calendar-grid .day .tooltip .see-more-btn:active {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
}
.calendar-container .calendar-grid .day .tooltip::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Bottom positioning arrow */
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom-left::before, .calendar-container .calendar-grid .day .tooltip.tooltip-bottom-right::before {
  top: -12px;
  border-bottom-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-left::before {
  left: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-bottom-right::before {
  right: 20px;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Top positioning arrow */
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-top-left::before, .calendar-container .calendar-grid .day .tooltip.tooltip-top-right::before {
  bottom: -12px;
  border-top-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-center::before {
  left: 50%;
  transform: translateX(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-left::before {
  left: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-top-right::before {
  right: 20px;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Right positioning arrow */
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-right-top::before, .calendar-container .calendar-grid .day .tooltip.tooltip-right-bottom::before {
  left: -12px;
  border-right-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-center::before {
  top: 50%;
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-top::before {
  top: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-right-bottom::before {
  bottom: 20px;
}
.calendar-container .calendar-grid .day .tooltip {
  /* Left positioning arrow */
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-center::before, .calendar-container .calendar-grid .day .tooltip.tooltip-left-top::before, .calendar-container .calendar-grid .day .tooltip.tooltip-left-bottom::before {
  right: -12px;
  border-left-color: #e2e8f0;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-center::before {
  top: 50%;
  transform: translateY(-50%);
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-top::before {
  top: 20px;
}
.calendar-container .calendar-grid .day .tooltip.tooltip-left-bottom::before {
  bottom: 20px;
}
.calendar-container {
  /* Monthly Summary Section */
}
.calendar-container .monthly-summary {
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--grey-lightest-shade);
  border: 1px solid var(--grey-shade-one);
  border-radius: var(--border-radius-primary);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.calendar-container .monthly-summary .summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--grey-shade-one);
}
.calendar-container .monthly-summary .summary-header h4 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.calendar-container .monthly-summary .summary-header h4::before {
  content: "";
  width: 6px;
  height: 6px;
  background: var(--primary-light-color);
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(58, 134, 255, 0.4);
}
.calendar-container .monthly-summary .summary-stats {
  display: flex;
  gap: 1rem;
}
.calendar-container .monthly-summary .summary-stats .stat-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: var(--border-radius-primary);
  transition: all 0.2s ease;
  cursor: default;
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat {
  background: var(--primary-light-bg);
  border: 1px solid rgba(0, 74, 154, 0.2);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat:hover {
  background: rgba(238, 242, 255, 0.8);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 74, 154, 0.1);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat .stat-content .stat-number {
  color: var(--primary-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.hearings-stat .stat-content .stat-label {
  color: var(--primary-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat {
  background: var(--success-light-bg);
  border: 1px solid rgba(22, 101, 52, 0.2);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat:hover {
  background: var(--success-dark-bg);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(22, 101, 52, 0.1);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat .stat-content .stat-number {
  color: var(--success-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item.tasks-stat .stat-content .stat-label {
  color: var(--success-color);
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-icon .icon-image {
  opacity: 0.8;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
}
.calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-label {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}
.calendar-container .monthly-summary {
  /* Responsive adjustments for summary */
}
@media (max-width: 768px) {
  .calendar-container .monthly-summary {
    margin-top: 1rem;
    padding: 0.75rem;
  }
  .calendar-container .monthly-summary .summary-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .calendar-container .monthly-summary .summary-header .fallback-note {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
  .calendar-container .monthly-summary .summary-stats {
    flex-direction: column;
    gap: 0.75rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item {
    padding: 0.5rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-icon {
    width: 36px;
    height: 36px;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
    font-size: 1.25rem;
  }
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-label {
    font-size: 0.7rem;
  }
}
@media (max-width: 480px) {
  .calendar-container .monthly-summary .summary-stats .stat-item .stat-content .stat-number {
    font-size: 1.1rem;
  }
}
.calendar-container {
  /* Show summary only when there's enough space */
}
@media (max-height: 700px) {
  .calendar-container .monthly-summary {
    display: none;
  }
}
.calendar-container {
  /* Also hide on very small screens where calendar takes most space */
}
@media (max-width: 480px) and (max-height: 800px) {
  .calendar-container .monthly-summary {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CalendarWidget/CalendarWidget.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EAEE,kBAAA;AAAJ;AAQE;EAEE,YAAA;EACA,oBAAA;AAPJ;AAUE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AARJ;AAUI;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AARN;AAUM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;EACA,YAAA;AARR;AAWM;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AATR;AAcE;EACE,aAAA;EACA,iBAAA;EACA,qCAAA;EACA,QAAA;EACA,SAAA;AAZJ;AAcI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;AAZN;AAeI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAbN;AAeM;EACE,cAAA;AAbR;AAgBM;EACE,aAAA;AAdR;AAiBM;EACE,mBAAA;EACA,qBAAA;AAfR;AAiBQ;EACE,gBAAA;EACA,cAAA;AAfV;AAmBM;EACE,mBAAA;EACA,yBAAA;AAjBR;AAmBQ;EACE,cAAA;AAjBV;AAqBM;EACE,uBAAA;EACA,YAAA;EACA,eAAA;AAnBR;AAsBM;EACE,2BAAA;EACA,yCAAA;EACA,mBAAA;EACA,qBAAA;AApBR;AAuBM;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AArBR;AAwBM;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtBR;AAyBM;EACE,6BAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,0EAAA;EAEA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAxBR;AA0BQ;EAIE,6BAAA;AA3BV;AA8BQ;EACE,qBAAA;EACA,SAAA;EACA,2BAAA;AA5BV;AA+BQ;EACE,wBAAA;EACA,SAAA;EACA,2BAAA;AA7BV;AAgCQ;EACE,QAAA;EACA,sBAAA;EACA,2BAAA;AA9BV;AAiCQ;EACE,QAAA;EACA,uBAAA;EACA,2BAAA;AA/BV;AAkCQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AAhCV;AAmCQ;EACE,UAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;AAjCV;AAoCQ;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAlCV;AAqCQ;EACE,YAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;AAnCV;AAsCQ;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AApCV;AA7CM;EAoFE,mBAAA;AApCR;AAqCQ;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,4BAAA;AAnCV;AAqCU;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;AAnCZ;AAqCY;EACE,mBAAA;AAnCd;AAsCY;EACE,yBAAA;AApCd;AAuCY;EACE,yBAAA;AArCd;AAwCY;EACE,gBAAA;EACA,cAAA;EACA,gCAAA;AAtCd;AAyCY;EACE,mBAAA;EACA,cAAA;AAvCd;AAxFM;EAoIE,iBAAA;AAzCR;AA0CQ;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAxCV;AA4CU;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;AA1CZ;AA4CY;EACE,eAAA;AA1Cd;AA8CU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5CZ;AAkDY;EACE,iBAAA;EACA,+BAAA;EAEA,kBAAA;EAEA,qBAAA;AAlDd;AAmDc;EACE,UAAA;AAjDhB;AAoDc;EACE,mBAAA;EACA,kBAAA;AAlDhB;AAqDc;EACE,mBAAA;EACA,kBAAA;AAnDhB;AAqDgB;EACE,mBAAA;AAnDlB;AAyDU;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAvDZ;AAyDY;EACE,eAAA;AAvDd;AAyDc;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,yCAAA;AAvDhB;AAyDc;EACE,mBAAA;EACA,qBAAA;AAvDhB;AAyDgB;EACE,mBAAA;EAEA,2BAAA;EACA,8CAAA;AAxDlB;AA6DY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA3Dd;AA6Dc;;EAEE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AA3DhB;AA8Dc;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AA5DhB;AA8DgB;EACE,mBAAA;EACA,cAAA;AA5DlB;AAiEY;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;AA/Dd;AAmEU;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAjEZ;AAmEY;EACE,gBAAA;EACA,cAAA;AAjEd;AAsEQ;EACE,kBAAA;EACA,6DAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,6BAAA;AApEV;AA0EU;EACE,6DAAA;AAxEZ;AA2EU;EACE,6DAAA;AAzEZ;AA6EQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AA3EV;AAzPM;EAuUE,6BAAA;AA3ER;AA4EQ;EAGE,UAAA;EACA,4BAAA;AA5EV;AA+EQ;EACE,SAAA;EACA,2BAAA;AA7EV;AAgFQ;EACE,UAAA;AA9EV;AAiFQ;EACE,WAAA;AA/EV;AA1QM;EA4VE,0BAAA;AA/ER;AAgFQ;EAGE,aAAA;EACA,yBAAA;AAhFV;AAmFQ;EACE,SAAA;EACA,2BAAA;AAjFV;AAoFQ;EACE,UAAA;AAlFV;AAqFQ;EACE,WAAA;AAnFV;AA3RM;EAiXE,4BAAA;AAnFR;AAoFQ;EAGE,WAAA;EACA,2BAAA;AApFV;AAuFQ;EACE,QAAA;EACA,2BAAA;AArFV;AAwFQ;EACE,SAAA;AAtFV;AAyFQ;EACE,YAAA;AAvFV;AA5SM;EAsYE,2BAAA;AAvFR;AAwFQ;EAGE,YAAA;EACA,0BAAA;AAxFV;AA2FQ;EACE,QAAA;EACA,2BAAA;AAzFV;AA4FQ;EACE,SAAA;AA1FV;AA6FQ;EACE,YAAA;AA3FV;AA1cA;EA2iBE,4BAAA;AA9FF;AA+FE;EACE,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,uCAAA;EACA,2CAAA;EACA,yCAAA;AA7FJ;AA+FI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AA7FN;AA+FM;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA7FR;AA+FQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,2CAAA;AA7FV;AAiGI;EACE,aAAA;EACA,SAAA;AA/FN;AAiGM;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;EACA,eAAA;AA/FR;AAiGQ;EACE,mCAAA;EACA,uCAAA;AA/FV;AAiGU;EACE,oCAAA;EACA,2BAAA;EACA,2CAAA;AA/FZ;AAkGU;EACE,2BAAA;AAhGZ;AAmGU;EACE,2BAAA;AAjGZ;AAqGQ;EACE,mCAAA;EACA,wCAAA;AAnGV;AAqGU;EACE,kCAAA;EACA,2BAAA;EACA,4CAAA;AAnGZ;AAsGU;EACE,2BAAA;AApGZ;AAuGU;EACE,2BAAA;AArGZ;AAyGQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAvGV;AAyGU;EACE,YAAA;AAvGZ;AA2GQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAzGV;AA2GU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAzGZ;AA4GU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AA1GZ;AATE;EAyHE,uCAAA;AA7GJ;AA8GI;EA1HF;IA2HI,gBAAA;IACA,gBAAA;EA3GJ;EA6GI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EA3GN;EA6GM;IACE,iBAAA;IACA,sBAAA;EA3GR;EA+GI;IACE,sBAAA;IACA,YAAA;EA7GN;EA+GM;IACE,eAAA;EA7GR;EA+GQ;IACE,WAAA;IACA,YAAA;EA7GV;EAgHQ;IACE,kBAAA;EA9GV;EAiHQ;IACE,iBAAA;EA/GV;AACF;AAoHI;EAEI;IACE,iBAAA;EAnHR;AACF;AA7lBA;EAqtBE,gDAAA;AArHF;AAsHE;EACE;IACE,aAAA;EApHJ;AACF;AArmBA;EA4tBE,oEAAA;AApHF;AAqHE;EACE;IACE,aAAA;EAnHJ;AACF","sourcesContent":[".calendar-container {\n  width: 85%;\n  padding-bottom: 1.5rem;\n  margin: auto;\n  overflow: visible !important;\n  min-height: fit-content;\n  display: flex;\n  flex-direction: column;\n\n  .day.empty {\n    // Hide empty cells completely\n    visibility: hidden;\n\n    // Or alternatively, just make them appear empty but maintain grid structure\n    // background: transparent;\n    // border: none;\n    // cursor: default;\n  }\n\n  .day.other-month {\n    // Style for days from other months (if any slip through)\n    opacity: 0.3;\n    pointer-events: none;\n  }\n\n  .calendar-header {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    position: relative;\n    z-index: 100;\n\n    select {\n      padding: 8px 12px;\n      border-radius: 8px;\n      border: 1px solid #d1d5db;\n      font-size: 14px;\n      background: #fff;\n      cursor: pointer;\n      position: relative;\n      z-index: 100;\n      pointer-events: auto;\n      color: #374151;\n\n      &:focus {\n        outline: none;\n        border-color: #3b82f6;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        z-index: 101;\n      }\n\n      option {\n        background: #fff;\n        color: #374151;\n        padding: 4px 8px;\n      }\n    }\n  }\n\n  .calendar-grid {\n    display: grid;\n    overflow: visible;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 8px;\n    flex: 1;\n\n    .weekday {\n      text-align: center;\n      font-weight: 600;\n      color: #6b7280;\n      padding: 8px;\n      font-size: 13px;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .day {\n      min-height: 40px;\n      padding: 6px;\n      border-radius: 8px;\n      background: #f9fafb;\n      border: 1px solid #e5e7eb;\n      position: relative;\n      cursor: pointer;\n      overflow: visible;\n      transition: all 0.2s ease;\n\n      &:hover {\n        z-index: 10000;\n      }\n\n      &.empty {\n        display: none;\n      }\n\n      &.today {\n        background: #dbeafe;\n        border-color: #3b82f6;\n\n        .day-number {\n          font-weight: 700;\n          color: #1d4ed8;\n        }\n      }\n\n      &.has-events {\n        background: #f0f9ff;\n        border: 2px solid #0ea5e9;\n\n        .event-count {\n          color: #0284c7;\n        }\n      }\n\n      &.empty {\n        background: transparent;\n        border: none;\n        cursor: default;\n      }\n\n      &:hover:not(.empty) {\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        background: #ffffff;\n        border-color: #94a3b8;\n      }\n\n      .day-number {\n        font-weight: 500;\n        color: #374151;\n        font-size: 14px;\n      }\n\n      .event-count {\n        font-size: 10px;\n        color: #0ea5e9;\n        margin-top: 2px;\n        font-weight: 600;\n      }\n\n      .tooltip {\n        position: absolute !important;\n        background: white;\n        z-index: 99999 !important;\n        border: 1px solid #e2e8f0;\n        border-radius: 12px;\n        padding: 0;\n        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12),\n          0 4px 8px rgba(0, 0, 0, 0.08);\n        min-width: 300px;\n        max-width: 380px;\n        backdrop-filter: blur(8px);\n        background: rgba(255, 255, 255, 0.98);\n        max-height: 210px;\n        display: flex;\n        flex-direction: column;\n\n        &.tooltip-top,\n        &.tooltip-bottom,\n        &.tooltip-left,\n        &.tooltip-right {\n          position: absolute !important;\n        }\n\n        &.tooltip-bottom {\n          top: calc(100% + 3px);\n          left: 50%;\n          transform: translateX(-50%);\n        }\n\n        &.tooltip-top {\n          bottom: calc(100% + 3px);\n          left: 50%;\n          transform: translateX(-50%);\n        }\n\n        &.tooltip-right {\n          top: 50%;\n          left: calc(100% + 3px);\n          transform: translateY(-50%);\n        }\n\n        &.tooltip-left {\n          top: 50%;\n          right: calc(100% + 3px);\n          transform: translateY(-50%);\n        }\n\n        .tooltip::before {\n          content: \"\";\n          position: absolute;\n          width: 0;\n          height: 0;\n          border: 6px solid transparent;\n        }\n\n        .tooltip-bottom::before {\n          top: -12px;\n          left: 50%;\n          transform: translateX(-50%);\n          border-bottom-color: #e2e8f0;\n        }\n\n        .tooltip-top::before {\n          bottom: -12px;\n          left: 50%;\n          transform: translateX(-50%);\n          border-top-color: #e2e8f0;\n        }\n\n        .tooltip-left::before {\n          right: -12px;\n          top: 50%;\n          transform: translateY(-50%);\n          border-left-color: #e2e8f0;\n        }\n\n        .tooltip-right::before {\n          left: -12px;\n          top: 50%;\n          transform: translateY(-50%);\n          border-right-color: #e2e8f0;\n        }\n\n        /* Tab Navigation */\n        .tooltip-tabs {\n          display: flex;\n          border-bottom: 1px solid #e2e8f0;\n          background: #f8fafc;\n          border-radius: 12px 12px 0 0;\n\n          .tab {\n            flex: 1;\n            padding: 12px 16px;\n            border: none;\n            background: transparent;\n            cursor: pointer;\n            font-size: 0.75rem;\n            font-weight: 600;\n            color: #6b7280;\n            transition: all 0.2s ease;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 6px;\n            border-radius: 12px 12px 0 0;\n\n            .tab-icon {\n              font-size: 0.875rem;\n            }\n\n            &:first-child {\n              border-radius: 12px 0 0 0;\n            }\n\n            &:last-child {\n              border-radius: 0 12px 0 0;\n            }\n\n            &.active {\n              background: #fff;\n              color: #374151;\n              border-bottom: 2px solid #3b82f6;\n            }\n\n            &:hover:not(.active) {\n              background: #f1f5f9;\n              color: #374151;\n            }\n          }\n        }\n\n        /* Content Area */\n        .tooltip-content {\n          padding: 16px;\n          flex: 1;\n          overflow-y: auto;\n        }\n\n        .tooltip-section {\n          .tooltip-title {\n            font-size: 0.875rem;\n            font-weight: 700;\n            margin-bottom: 12px;\n            color: #1f2937;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            padding-bottom: 8px;\n            border-bottom: 1px solid #f1f5f9;\n\n            .section-icon {\n              font-size: 1rem;\n            }\n          }\n\n          .tooltip-items {\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n\n            // &>*:last-child {\n            //   margin-bottom: 8px;\n            // }\n\n            &.scrollable {\n              max-height: 200px;\n              /* Limit height for scrolling */\n              // overflow-y: auto;\n              padding-right: 4px;\n\n              /* Custom scrollbar */\n              &::-webkit-scrollbar {\n                width: 4px;\n              }\n\n              &::-webkit-scrollbar-track {\n                background: #f1f5f9;\n                border-radius: 2px;\n              }\n\n              &::-webkit-scrollbar-thumb {\n                background: #cbd5e1;\n                border-radius: 2px;\n\n                &:hover {\n                  background: #94a3b8;\n                }\n              }\n            }\n          }\n\n          .tooltip-item {\n            padding: 10px 12px;\n            border-radius: 8px;\n            background: #eef2ff;\n            border: 1px solid #e2e8f0;\n            transition: all 0.2s ease;\n\n            &.clickable {\n              cursor: pointer;\n\n              &:hover {\n                background: #d8e3f7;\n                border-color: #cbd5e1;\n                transform: translateY(-1px);\n                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n              }\n              &.task-item {\n                background: #f0fdf4;\n                border-color: #bbf7d0; \n\n                &:hover {\n                  background: #d1fae5; \n                  //border-color: #10b981; \n                  transform: translateY(-1px);\n                  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15); \n                }\n              }\n            }\n\n            .item-header {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              margin-bottom: 6px;\n\n              .court-ref,\n              .task-name {\n                font-size: 0.75rem;\n                font-weight: 600;\n                color: #374151;\n                flex: 1;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                margin-right: 8px;\n              }\n\n              .item-badge {\n                font-size: 0.625rem;\n                padding: 2px 6px;\n                border-radius: 4px;\n                font-weight: 600;\n                text-transform: uppercase;\n                background: #dbeafe;\n                color: #1e40af;\n                white-space: nowrap;\n\n                &.task-badge {\n                  background: #fef3c7;\n                  color: #92400e;\n                }\n              }\n            }\n\n            .item-details {\n              font-size: 0.6875rem;\n              color: #6b7280;\n              line-height: 1.4;\n              font-weight: 400;\n              display: -webkit-box;\n              -webkit-line-clamp: 2;\n              line-clamp: 2;\n              -webkit-box-orient: vertical;\n              overflow: hidden;\n            }\n          }\n\n          .tooltip-more {\n            font-size: 0.75rem;\n            color: #6b7280;\n            font-weight: 500;\n            padding: 8px 12px;\n            background: #f1f5f9;\n            border-radius: 6px;\n            text-align: center;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 4px;\n            margin-top: 4px;\n\n            .more-icon {\n              font-weight: 700;\n              color: #3b82f6;\n            }\n          }\n        }\n\n        .see-more-btn {\n          padding: 12px 16px;\n          background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n          color: #fff;\n          border: none;\n          border-radius: 0 0 12px 12px;\n          font-size: 0.75rem;\n          cursor: pointer;\n          font-weight: 600;\n          transition: all 0.2s ease;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 6px;\n          border-top: 1px solid #e2e8f0;\n\n          // .btn-icon {\n          //   font-size: 0.875rem;\n          // }\n\n          &:hover {\n            background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n          }\n\n          &:active {\n            background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);\n          }\n        }\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          width: 0;\n          height: 0;\n          border: 6px solid transparent;\n        }\n\n        /* Bottom positioning arrow */\n        &.tooltip-bottom-center::before,\n        &.tooltip-bottom-left::before,\n        &.tooltip-bottom-right::before {\n          top: -12px;\n          border-bottom-color: #e2e8f0;\n        }\n\n        &.tooltip-bottom-center::before {\n          left: 50%;\n          transform: translateX(-50%);\n        }\n\n        &.tooltip-bottom-left::before {\n          left: 20px;\n        }\n\n        &.tooltip-bottom-right::before {\n          right: 20px;\n        }\n\n        /* Top positioning arrow */\n        &.tooltip-top-center::before,\n        &.tooltip-top-left::before,\n        &.tooltip-top-right::before {\n          bottom: -12px;\n          border-top-color: #e2e8f0;\n        }\n\n        &.tooltip-top-center::before {\n          left: 50%;\n          transform: translateX(-50%);\n        }\n\n        &.tooltip-top-left::before {\n          left: 20px;\n        }\n\n        &.tooltip-top-right::before {\n          right: 20px;\n        }\n\n        /* Right positioning arrow */\n        &.tooltip-right-center::before,\n        &.tooltip-right-top::before,\n        &.tooltip-right-bottom::before {\n          left: -12px;\n          border-right-color: #e2e8f0;\n        }\n\n        &.tooltip-right-center::before {\n          top: 50%;\n          transform: translateY(-50%);\n        }\n\n        &.tooltip-right-top::before {\n          top: 20px;\n        }\n\n        &.tooltip-right-bottom::before {\n          bottom: 20px;\n        }\n\n        /* Left positioning arrow */\n        &.tooltip-left-center::before,\n        &.tooltip-left-top::before,\n        &.tooltip-left-bottom::before {\n          right: -12px;\n          border-left-color: #e2e8f0;\n        }\n\n        &.tooltip-left-center::before {\n          top: 50%;\n          transform: translateY(-50%);\n        }\n\n        &.tooltip-left-top::before {\n          top: 20px;\n        }\n\n        &.tooltip-left-bottom::before {\n          bottom: 20px;\n        }\n      }\n    }\n  }\n\n  /* Monthly Summary Section */\n  .monthly-summary {\n    margin-top: 1.5rem;\n    padding: 1rem;\n    background: var(--grey-lightest-shade);\n    border: 1px solid var(--grey-shade-one);\n    border-radius: var(--border-radius-primary);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n    .summary-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 1rem;\n      padding-bottom: 0.75rem;\n      border-bottom: 1px solid var(--grey-shade-one);\n\n      h4 {\n        margin: 0;\n        font-size: 0.9rem;\n        font-weight: 600;\n        color: var(--primary-color);\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        &::before {\n          content: \"\";\n          width: 6px;\n          height: 6px;\n          background: var(--primary-light-color);\n          border-radius: 50%;\n          box-shadow: 0 0 8px rgba(58, 134, 255, 0.4);\n        }\n      }\n    }\n    .summary-stats {\n      display: flex;\n      gap: 1rem;\n\n      .stat-item {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n        padding: 0.75rem;\n        border-radius: var(--border-radius-primary);\n        transition: all 0.2s ease;\n        cursor: default;\n\n        &.hearings-stat {\n          background: var(--primary-light-bg);\n          border: 1px solid rgba(0, 74, 154, 0.2);\n\n          &:hover {\n            background: rgba(238, 242, 255, 0.8);\n            transform: translateY(-1px);\n            box-shadow: 0 4px 8px rgba(0, 74, 154, 0.1);\n          }\n\n          .stat-content .stat-number {\n            color: var(--primary-color);\n          }\n\n          .stat-content .stat-label {\n            color: var(--primary-color);\n          }\n        }\n\n        &.tasks-stat {\n          background: var(--success-light-bg);\n          border: 1px solid rgba(22, 101, 52, 0.2);\n\n          &:hover {\n            background: var(--success-dark-bg);\n            transform: translateY(-1px);\n            box-shadow: 0 4px 8px rgba(22, 101, 52, 0.1);\n          }\n\n          .stat-content .stat-number {\n            color: var(--success-color);\n          }\n\n          .stat-content .stat-label {\n            color: var(--success-color);\n          }\n        }\n\n        .stat-icon {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 40px;\n          height: 40px;\n\n          .icon-image {\n            opacity: 0.8;\n          }\n        }\n\n        .stat-content {\n          display: flex;\n          flex-direction: column;\n          gap: 0.25rem;\n\n          .stat-number {\n            font-size: 1rem;\n            font-weight: 700;\n            line-height: 1;\n          }\n\n          .stat-label {\n            font-size: 0.8rem;\n            font-weight: 600;\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n            opacity: 0.8;\n          }\n        }\n      }\n    }\n\n    /* Responsive adjustments for summary */\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n      padding: 0.75rem;\n\n      .summary-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n\n        .fallback-note {\n          font-size: 0.7rem;\n          padding: 0.2rem 0.4rem;\n        }\n      }\n\n      .summary-stats {\n        flex-direction: column;\n        gap: 0.75rem;\n\n        .stat-item {\n          padding: 0.5rem;\n\n          .stat-icon {\n            width: 36px;\n            height: 36px;\n          }\n\n          .stat-content .stat-number {\n            font-size: 1.25rem;\n          }\n\n          .stat-content .stat-label {\n            font-size: 0.7rem;\n          }\n        }\n      }\n    }\n\n    @media (max-width: 480px) {\n      .summary-stats .stat-item {\n        .stat-content .stat-number {\n          font-size: 1.1rem;\n        }\n      }\n    }\n  }\n\n  /* Show summary only when there's enough space */\n  @media (max-height: 700px) {\n    .monthly-summary {\n      display: none;\n    }\n  }\n\n  /* Also hide on very small screens where calendar takes most space */\n  @media (max-width: 480px) and (max-height: 800px) {\n    .monthly-summary {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
